// src/App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Box } from "@mui/material";
import Header from "./components/Header";
import FormSection from "./components/FormSection";
import Services from "./components/Services";
import AboutPracco from "./components/AboutPracco";
import Partner from "./components/PartnerUs";
import QuerySupportSection from "./components/QuerySupportSection";
import ClientLogos from "./components/ClientLogo";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import ScrollToHashElement from "./components/ScrollToHashElement";
import ChatWidget from "./components/ChatWidget";
import FAQSection from "./components/FAQSection";
import CompanyRegistrationPage from "./pages/CompanyRegistrationPage";
import GSTRegistrationPage from "./pages/GSTRegistrationPage";
import IncomeTaxFilingPage from "./pages/IncomeTaxFilingPage";
import AccountingPage from "./pages/AccountingPage";
import TrademarkPage from "./pages/TrademarkPage";

const HomePage = () => (
  <Box id="home">
    <ScrollToHashElement />
    <Header />
    <FormSection />
    <AboutPracco />
    <Services />
    <Partner />
    <QuerySupportSection />
    <ClientLogos />
    <Testimonials />
    <FAQSection />
    <Footer />
    <ChatWidget />
  </Box>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/company-registration" element={<CompanyRegistrationPage />} />
          <Route path="/gst-registration" element={<GSTRegistrationPage />} />
          <Route path="/income-tax-filing" element={<IncomeTaxFilingPage />} />
          <Route path="/accounting-bookkeeping" element={<AccountingPage />} />
          <Route path="/trademark-registration" element={<TrademarkPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
